import axiosInstance from "./axiosInstance";

const BASE = "/order-success-page-settings/";

export const getOrderSuccessPageSettings = () => axiosInstance.get(BASE);

export const updateOrderSuccessPageSettings = (data) => axiosInstance.put(BASE, data);